
import { CareRecipientHouseId } from "../care_recipient/CareRecipientHouseId";
import { CareRecipientId } from "../care_recipient/CareRecipientId";
import { CareRecipientName } from "../care_recipient/CareRecipientName";
import { DateTime } from "../fundamental/DateTime";
import { UserEmail } from "../user/UserEmail";
import { UserId } from "../user/UserId";
import { UserName } from "../user/UserName";
import { InquiryStatus } from "./Inquiry";
import { InquiryCategory } from "./InquiryCategory";
import { InquiryContent } from "./InquiryContent";
import { InquiryId } from "./InquiryId";
import { InquiryMemo } from "./InquiryMemo";

const InquiryDetailType = Symbol();

export class InquiryDetail {
    [InquiryDetailType]: any;
    readonly id: InquiryId;
    readonly user: { id: UserId, name: UserName, email: UserEmail } | null;
    readonly careRecipient: { id: CareRecipientId, name: CareRecipientName, houseId: CareRecipientHouseId } | null;
    readonly createdAt: DateTime;
    readonly category: InquiryCategory;
    readonly status: InquiryStatus;
    readonly content: InquiryContent;
    readonly tel: string | null;
    readonly memo: InquiryMemo | null;
    readonly contactEmail: UserEmail;

    private constructor(
        id: InquiryId,
        user: { id: UserId, name: UserName, email: UserEmail } | null,
        careRecipient: { id: CareRecipientId, name: CareRecipientName, houseId: CareRecipientHouseId } | null,
        createdAt: DateTime,
        category: InquiryCategory,
        status: InquiryStatus,
        content: InquiryContent,
        tel: string | null,
        memo: InquiryMemo | null,
        contactEmail: UserEmail
    ) {
        this.id = id;
        this.user = user;
        this.careRecipient = careRecipient;
        this.createdAt = createdAt;
        this.category = category;
        this.content = content;
        this.status = status;
        this.tel = tel;
        this.memo = memo;
        this.contactEmail = contactEmail;
    }

    static from(
        id: InquiryId,
        user: { id: UserId, name: UserName, email: UserEmail } | null,
        careRecipient: { id: CareRecipientId, name: CareRecipientName, houseId: CareRecipientHouseId } | null,
        createdAt: DateTime,
        category: InquiryCategory,
        status: InquiryStatus,
        content: InquiryContent,
        tel: string | null,
        memo: InquiryMemo | null,
        contactEmail: UserEmail
    ): InquiryDetail {
        return new InquiryDetail(
            id,
            user,
            careRecipient,
            createdAt,
            category,
            status,
            content,
            tel,
            memo,
            contactEmail
        );
    }
}

export type InquiryDetailJson = {
    id: string,
    user: {
        id: string,
        name: string,
        email: string
    } | null,
    careRecipient: {
        id: string,
        name: string,
        houseId: string
    } | null,
    createdAt: string,
    category: string,
    status: InquiryStatus,
    content: string,
    tel: string | null,
    memo: string | null,
    contactEmail: string,
}
